module.exports = __webpack_public_path__ + "img/undertakingCases1.ea14ca81.jpg";